import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  DestroyRef,
  Inject,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { SpinnerService, ToastAlertService } from '@core/services';
import { Building, Roles, WorkerGroup } from '../../../models';
import { Business } from '../../../models/business.model';
import {
  BuildingService,
  BusinessService,
  RoleService,
  UserGroupService,
  UserService,
} from '../../../services';
import { Cookies } from 'typescript-cookie';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgFor } from '@angular/common';
import { InputComponent } from '@shared/components/input/input.component';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-user-create-modal',
  templateUrl: './user-create-modal.component.html',
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    ReactiveFormsModule,
    MatDialogContent,
    InputComponent,
    NgIf,
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class UserCreateModalComponent implements OnInit {
  formBuilder = inject(FormBuilder);
  // Validations
  public operation = '';
  public userForm!: any;
  public toCreate!: boolean;
  public isSysAdmin = false;
  public isAccess = false;
  // Services
  private buildingService = inject(BuildingService);
  private roleService = inject(RoleService);
  private userService = inject(UserService);
  private bussinesService = inject(BusinessService);
  private groupServices = inject(UserGroupService);
  private alertService = inject(ToastAlertService);
  private _spinner = inject(SpinnerService);
  // DATA
  public Groups: WorkerGroup[] = [];
  public Buildings: Building[] = [];
  private initialRoles: Roles[] = [];
  public Roles: Roles[] = [];
  public Business: Business[] = [];
  public selectedBussines = 0;
  public selectedRole = 0;
  public bussinessWorker = 0;
  sysadminselect: boolean = true;
  workerCodes: string[] = [];
  public typeForm = this.data.data;
  codeEdit = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UserCreateModalComponent>
  ) {
    this.buildform();
    this.dialogRef.disableClose = true;
    this.codeEdit = this.data?.data?.user_code;
  }

  private destroyRef = inject(DestroyRef);
  roleName = signal<string>('');
  async ngOnInit() {
    this.roleName.set(Cookies.get('role')!.toString());
    await this.loadinit();

    this.ChargeRoleWorker();
    this.getRoles();

    this.setValidatos();
  }

  async loadinit() {
    this._spinner.show();
    await this.getBussines();
  }
  setValidatos() {
    this.userForm.get('role_id').valueChanges.subscribe((rol: string) => {
      if (this.isSysAdmin) {
        if (rol == '10') {
          this.userForm.get('businessId').setValidators([]);
        } else {
          this.userForm.get('businessId').setValidators([Validators.required]);
        }
        this.userForm.get('businessId').updateValueAndValidity();
      }
    });

    if (this.bussinessWorker != 0 && !this.isSysAdmin) {
      this.userForm.get('businessId').setValidators([]);
      this.userForm.get('businessId').updateValueAndValidity();
    }
    if (this.data.type == 'Editar' && this.data.data.roleId == 4) {
      this.userForm.get('workerGroupId').setValidators([Validators.required]);
      this.userForm.get('buildingId').setValidators([Validators.required]);
      this.userForm.get('businessId').updateValueAndValidity();
    }
  }

  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.toUpperCase();
    this.userForm.patchValue({ user_code: inputValue }, { emitEvent: false });
  }

  getGroups() {
    let business = Cookies.get('bussinesId');

    if (business == null) {
      business = this.userForm.value.businessId;
    }

    if (business != null) {
      this.groupServices
        .getUserGroupsbybussiness(business.toString())
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (request: any) => {
            if (request.code === 10000) {
              this.Groups = request.reply;
            }
          },
        });
    }
  }

  async getBussines() {
    await this.bussinesService
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.Business = request.reply;

            // cambios de empresa
            console.log(this.data);
            const business = Cookies.get('bussinesId');
            console.log('bussiness', business);
            if (business !== null && business !== undefined) {
              this.bussinessWorker = parseInt(business!.toString());
              this.whenChangeBusiness();
            }

            console.log(this.userForm.value);
            if (this.userForm.value.businessId != 0) {
              this.selectedBussines = parseInt(
                this.userForm.value.businessId!.toString()
              );
              this.whenChangeBusiness();
            }
            this._spinner.hide();
          }
        },
      });
  }

  getRoles() {
    this.roleService
      .getRoles()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.initialRoles = request.reply;
            const map: Roles[] = request.reply;
            if (this.roleName() !== 'ACCESOS') {
              //!QUITA SYSADMIN
              const index = map.findIndex(
                role => role.roleid.toString() === '10'
              );

              if (index !== -1) {
                map.splice(index, 1);
              }

              //!QUITA ACCESOS
              const index2 = map.findIndex(
                role => role.roleid.toString() === '12'
              );

              if (index2 !== -1) {
                map.splice(index2, 1);
              }
              this.Roles = map;
              this.whenCheckBoxChange();
            } else {
              // Filtra solo roles 10 y 12
              const RoleFilter = map.filter(
                role =>
                  role.roleid.toString() === '10' ||
                  role.roleid.toString() === '12'
              );
              this.Roles = RoleFilter;
            }
          }
        },
      });
  }
  ChargeRoleWorker() {
    const role = Cookies.get('role');
    if (role != null) {
      if (role == 'SYSADMIN') {
        this.isSysAdmin = true;
      } else {
        this.isSysAdmin = false;
      }

      if (role == 'ACCESOS') {
        this.isAccess = true;
      } else {
        this.isAccess = false;
      }
    }
  }

  whenRolesChange() {
    const obj = this.Roles.find(item => item.roleid === this.selectedRole);
    if (obj?.name == 'SYSADMIN' || obj?.name == 'ACCESOS') {
      this.sysadminselect = false;
    } else {
      this.sysadminselect = true;
    }
  }

  whenCheckBoxChange() {
    if (this.data.data == 'checkWeb') {
      this.Roles = this.initialRoles.filter(item => item.type == 'web');
    } else {
      this.Roles = this.initialRoles.filter(item => item.type == 'application');
    }
  }

  public onSubmit(): void {
    if (this.userForm.valid) {
      if (this.data.type == 'Crear') {
        const data = {
          businessId: this.userForm.value.businessId,
          email: this.userForm.value.email,
          secondEmail: this.userForm.value.secondEmail,
          password: this.userForm.value.password,
          phone: this.userForm.value.phone,
          address: this.userForm.value.address,
          buildingId: this.userForm.value.buildingId,
          workerGroupId:
            this.userForm.value.workerGroupId == 0
              ? null
              : this.userForm.value.workerGroupId,
          first_name: this.userForm.value.first_name,
          last_name: this.userForm.value.last_name,
          user_name: this.userForm.value.user_name,
          role_id: this.userForm.value.role_id,
          type_login: 0,
        };
        if (this.data.data == 'checkApp' && this.data.isparking === '1') {
          data.role_id = 11;
        } else if (this.data.data == 'checkApp') {
          data.role_id = 4;
        } //FIX ROLE
        if (data.businessId == '') {
          data.businessId =
            this.bussinessWorker === 0
              ? this.selectedBussines
              : this.bussinessWorker;
        } //FIX BUSSINESS_ID
        if (
          (!this.sysadminselect && this.data.data != 'checkApp') ||
          data.businessId == 0
        ) {
          delete data.businessId;
        } //FIX DELETE BUSSINES SYSADMIN
        if (
          this.userForm.value.workerGroupId == 0 ||
          this.userForm.value.workerGroupId == null
        ) {
          delete data.workerGroupId;
        } //FIX GROUP
        if (
          this.userForm.value.buildingId == 0 ||
          this.userForm.value.buildingId == null
        ) {
          delete data.buildingId;
        } //FIX GROUP
        if (data.role_id == '') {
          delete data.role_id;
        } //FIX ROLE_ID

        let cadena: string = data.password;
        cadena = cadena.trim();
        data.password = cadena;

        this.userService.storeUserApp(data).subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.alertService.sucess(`Usuario creado con éxito`);
              this.dialogRef.close(true);
            } else {
              this.alertService.error(resp.detail);
            }
          },
          error: error => {
            this.alertService.error(`Error: ${error}`);
          },
        });
      } else {
        const data = {
          worker_id: this.data.data.worker_id,
          businessId: this.userForm.value.businessId,
          email: this.userForm.value.email,
          secondEmail: this.userForm.value.secondEmail,
          phone: this.userForm.value.phone,
          address: this.userForm.value.address,
          buildingId: this.userForm.value.buildingId,
          workerGroupId: this.userForm.value.workerGroupId,
          first_name: this.userForm.value.first_name,
          last_name: this.userForm.value.last_name,
          user_name: this.userForm.value.user_name,
        };
        if (this.userForm.value.businessId == null) {
          delete data.businessId;
        } //FIX BUSSINESS_ID
        if (
          this.userForm.value.workerGroupId == 0 ||
          this.userForm.value.workerGroupId == null
        ) {
          delete data.workerGroupId;
        } //FIX GROUP
        if (
          this.userForm.value.buildingId == 0 ||
          this.userForm.value.buildingId == null ||
          data.address == null
        ) {
          delete data.buildingId;
        } //FIX GROUP
        if (data.address == null) {
          data.address = '--';
        }

        this.userService.updateUser(data, data.worker_id).subscribe({
          next: resp => {
            this.dialogRef.close(true);
            if (resp.code === 10000) {
              this.alertService.sucess(`Usuario modificado con éxito`);
            } else {
              this.alertService.error(resp.detail);
            }
          },
          error: error => {
            this.alertService.error(`Error: ${error}`);
          },
        });
      }
    }
  }
  filterPhone =
    '^\\+?\\(?[1-9]\\d{0,2}\\)?\\s?\\d{1,4}\\s?\\d{1,4}\\s?\\d{0,4}$';
  private buildform() {
    if (this.data?.type == 'Editar') {
      this.userForm = this.formBuilder.group({
        first_name: [this.data.data.first_name, Validators.required],
        last_name: [this.data.data.last_name, Validators.required],
        user_name: [this.data.data.user_name, Validators.required],
        email: [this.data.data.email, [Validators.required, Validators.email]],
        secondEmail: [
          this.data.data.secondEmail,
          [Validators.required, Validators.email],
        ],
        phone: [this.data.data.phone, Validators.pattern(this.filterPhone)],
        role_id: [this.data.data.role_id],
        address: [this.data.data.address, Validators.required],
        businessId: [this.data.data.business_id],
        buildingId: [this.data.data.building_id],
        workerGroupId: [parseInt(this.data.data.workerGroupId)],
      });
    } else {
      if (this.data.data == 'checkWeb') {
        this.userForm = this.formBuilder.group({
          first_name: ['', Validators.required],
          last_name: ['', Validators.required],
          user_name: ['', Validators.required],
          password: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          secondEmail: ['', [Validators.required, Validators.email]],
          address: ['', Validators.required],
          phone: ['', Validators.pattern(this.filterPhone)],
          role_id: ['', Validators.required],
          businessId: [''],
          buildingId: [''],
          workerGroupId: [''],
        });
      } else {
        this.userForm = this.formBuilder.group({
          first_name: ['', Validators.required],
          last_name: ['', Validators.required],
          user_name: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          secondEmail: ['', [Validators.required, Validators.email]],
          phone: ['', Validators.pattern(this.filterPhone)],
          role_id: [''],
          businessId: ['', Validators.required],
          address: ['', Validators.required],
          password: ['', Validators.required],
          buildingId: ['', Validators.required],
          workerGroupId: ['', Validators.required],
        });
      }
    }
  }

  async whenChangeBusiness() {
    this.getGroups();
    this.Buildings = [];
    const business = Cookies.get('bussinesId');
    const envio =
      this.selectedBussines !== 0
        ? this.selectedBussines
        : parseInt(business!.toString());
    console.log('envio', envio);
    this.buildingService
      .getBuildingsByBusiness(envio)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.Buildings = request.reply;
            this.userService
              .getUsersByBussines(envio)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((request: any) => {
                if (request.code === 10000) {
                  this.workerCodes = [];
                  request.reply.forEach((item: { user_code: string }) => {
                    this.workerCodes.push(item.user_code);
                  });
                }
              });
          }
        },
      });
  }
}
